export const SOURCE_ICON_BY_CODE = {
    js: "/assets/images/typeImages/web-icon.png",
    redirect: "/assets/images/typeImages/redirect.png",
    capi: "/assets/images/typeImages/offline-icon.webp",
    dynamics: "/assets/images/typeImages/microsoft-dynamics-logo.png",
    ftp: "/assets/images/typeImages/ftp-icon.png",
    sftp: "/assets/images/typeImages/sftp-icon.png",
    salesforce: "/assets/images/typeImages/sales.png",
    zoho: "/assets/images/typeImages/zoho.png",
    hub: "/assets/images/typeImages/hubspot-icon.png",
    monday: "/assets/images/typeImages/monday.png",
    zendesk_sell: "/assets/images/typeImages/zendesk-icon.png",
    pipe: "/assets/images/typeImages/pipedrive.png",
    b24: "/assets/images/typeImages/b24.png",
    upload: "/assets/images/typeImages/file-upload-icon.png",
    spreadsheet: "/assets/images/typeImages/google-sheets-icon.png",
    freshsales: "/assets/images/typeImages/freshsales-crm.png",
    vtiger: "/assets/images/typeImages/vtiger-crm.png",
    odoo: "/assets/images/typeImages/odoo.png",
    lsqrd: "/assets/images/typeImages/leadsquared.png",
    appsflyer: "/assets/images/typeImages/appsflyer.png",
    adjust: "/assets/images/typeImages/adjust.png",
    bigquery: "/assets/images/typeImages/bigquery.png",
    androidcapi: "/assets/images/typeImages/androidcapi.png",
    ioscapi: "/assets/images/typeImages/ioscapi.png",
    msg: "/assets/images/typeImages/messaging.png",
};

/** Same wordmark the sidebar uses. Shown for source types we have no icon for. */
export const SIGNALSIGHT_LOGO = "/assets/images/signal-sight.png";

export const getSourceIconByCode = (code) =>
    SOURCE_ICON_BY_CODE[code] ?? SIGNALSIGHT_LOGO;

const getSourceIcon = (sources, sourceTypeId) => {
    const source = sources?.find(
        (item) => item.source_type_id === sourceTypeId,
    );

    return getSourceIconByCode(source?.source_type?.code);
};

export default getSourceIcon;
